import { Spin, Table, Tag, Typography, theme } from 'antd'
import { SectionCard } from '../../Common/Layout'
import { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from 'react'
import { ReleaseUpdateTypes } from '../../Services/UpdatesService';
import dayjs from 'dayjs';
import { LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import DashboardService from '../../Services/DashboardService';
import { EmptyIcon } from '../../Common/FullPageSpinner';

interface DataType {
    key: string;
    version: string;
    date: string;
    title: string;
    type: string;
}

interface IProps{
    fromDate:string,
    toDate:string
}
const UpdateCard = ({fromDate,toDate}:IProps) => {
    const { token } = theme.useToken();
    const [loading,setLoading] = useState(false);
    const [updateData,setUpdateData] = useState<DataType[]>([])
    const [totalUpdate,setTotalUpdate] = useState(0)

    const updatesColumns:ColumnsType<DataType> = [
        {
            title: <span style={{ fontSize: '12px', fontWeight: 600, color: token.colorTextSecondary, letterSpacing: '0.02em' }}>Version</span>,
            dataIndex: "version",
            key: "version",
            width: '12%',
        },
        {
            title: <span style={{ fontSize: '12px', fontWeight: 600, color: token.colorTextSecondary,letterSpacing: '0.02em' }}>Date</span>,
            dataIndex: "date",
            key: "date",
            width:"18%",
            render:(itm)=>{
                return <span style={{ color: token.colorTextSecondary, fontSize: 13 }}>{dayjs(itm).format("DD/MM/YYYY")}</span>
            }
        },
        {
            title: <span style={{ fontSize: '12px', fontWeight: 600, color: token.colorTextSecondary, letterSpacing: '0.02em' }}>Title</span>,
            dataIndex: "title",
            key: "title",
            width: '50%',
            render: (text: string) => (
            <Typography.Text
                ellipsis={{
                tooltip: {
                    title: text,
                    placement: 'topLeft'
                }
                }}
                style={{ fontSize: 13, fontWeight: 500, color: token.colorText }}
            >
                {text}
            </Typography.Text>
            ),
        },
        {
            title: <span style={{ fontSize: '12px', fontWeight: 600, color: token.colorTextSecondary,letterSpacing: '0.02em' }}>Type</span>,
            dataIndex: 'type',
            key: 'type',
            width:"20%",
            render: (type: string) => {
                const color = type === 'Enhancement' ? 'blue' : type === 'Development' ? 'green' : 'orange';
                return <Tag color={color} style={{ borderRadius: 6, fontWeight: 600, fontSize: 11, border: 'none' }}>{type}</Tag>;
            },
        },

    ];


    const getUpdateList = async () => {
        try {
            setLoading(true);
            const res = await DashboardService.getUpdateDetails(fromDate,toDate,0,10,"Date","descend")
            if(res?.result && res?.result?.items && res?.status){
                let updateList:DataType[] = res?.result?.items?.map((e:any)=>(
                    {
                        key: e?.id,
                        version: e?.version,
                        date: e?.date,
                        title: e?.title,
                        type: ReleaseUpdateTypes[e?.type]
                    }
                )) || []
                setUpdateData(updateList)
                setTotalUpdate(res?.result?.totalRecords || 0)
            }
            else{
                setUpdateData([])
            }

        } catch (error) {
            console.error(error)
        }
        finally{
            setLoading(false);
        }
    }

    useEffect(()=>{
        getUpdateList()
    },[fromDate,toDate])


    return (
      <>
        <SectionCard
          title={
            <span
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              Updates
              <span
                style={{
                  background: "linear-gradient(130deg, #6c8ef5, #3F5BD3)",
                  height: 18,
                  minWidth: 18,
                  padding: "0 6px",
                  color: "#fff",
                  fontSize: 11,
                  fontWeight: 700,
                  borderRadius: 9,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {updateData.length}
              </span>
            </span>
          }
          extra={
            <Link
              style={{ color: "#3F5BD3", fontSize: 12, fontWeight: 600 }}
              to="/updates"
              target="_blank"
            >
              View All
            </Link>
          }
          style={{
            width: "100%",
            maxHeight: 538,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Spin
            spinning={loading}
            indicator={
              <LoadingOutlined
                style={{ fontSize: 30, color: "#3F5BD3" }}
                spin
              />
            }
          >
            {updateData && updateData.length > 0 ? (
              <Table
                tableLayout="fixed"
                columns={updatesColumns}
                dataSource={updateData}
                pagination={false}
                size="small"
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: 20,
                  gap: 8,
                }}
              >
                <EmptyIcon />
              </div>
            )}
          </Spin>
        </SectionCard>
      </>
    );
}

export default UpdateCard